import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FlexLayoutModule } from '@angular/flex-layout'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { MatAutocompleteModule } from '@angular/material/autocomplete'
import { MatButtonModule } from '@angular/material/button'
import { MatDialogModule } from '@angular/material/dialog'
import { MatDividerModule } from '@angular/material/divider'
import { MatInputModule } from '@angular/material/input'
import { MatProgressBarModule } from '@angular/material/progress-bar'
import { MatSelectModule } from '@angular/material/select'
import { MatSnackBarModule } from '@angular/material/snack-bar'
import { PipesModule } from '@mmx/pipes'
import { TranslateModule } from '@ngx-translate/core'

import { DateFieldModule } from '../date-selector'
import { InsuranceDialogComponent } from './insurance-dialog.component'

@NgModule({
  declarations: [
    InsuranceDialogComponent,
  ],
  imports: [
    CommonModule,
    DateFieldModule,
    FlexLayoutModule,
    FormsModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatDialogModule,
    MatDividerModule,
    MatInputModule,
    MatProgressBarModule,
    MatSelectModule,
    MatSnackBarModule,
    PipesModule,
    ReactiveFormsModule,
    TranslateModule,
  ],
  exports: [InsuranceDialogComponent],
})
export class InsuranceDialogModule {}
